import { combineReducers } from 'redux';
import {routerReducer} from 'react-router-redux';
import locationsReducer from './locations';
import websiteReducer from './website';
import authReducer from './auth';
import usersReducer from './users';
import stationsReducer from './stations';
import referenceReducer from './reference';
import { navReducer } from './nav';
import companiesReducer from './companies';
import waitlistReducer from './waitlist';

const rootReducer = combineReducers({
  routing: routerReducer,
  locationsEndpoint: locationsReducer,
  websiteEndpoint: websiteReducer,
  authEndpoint: authReducer,
  usersEndpoint: usersReducer,
  stationsEndpoint: stationsReducer,
  referenceData: referenceReducer,
  nav: navReducer,
  companiesEndpoint: companiesReducer,
  waitlistEndpoint: waitlistReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js